<template>
    <div class="admin-config-page">
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{ trans('general.basic') }}</h3>
                    <div class="nk-block-des text-soft">
                        <p>Manage company identity and contact details used across customer-facing records.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="basic"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner">
                    <show-tip class="mb-4" module="configuration" tip="tip_basic_configuration"></show-tip>
                    <form @submit.prevent="submit" @keydown="configForm.errors.clear($event.target.name)">
                        <section class="admin-config-section" :aria-label="trans('general.basic')">
                            <h4 class="admin-config-section__title">{{ trans('general.basic') }}</h4>
                            <p class="admin-config-section__description">Primary company identity shown across invoices, emails, and admin records.</p>
                            <div class="row">
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.company_name')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.company_name" name="company_name" :placeholder="trans('configuration.company_name')">
                                    <show-error :form-name="configForm" prop-name="company_name"></show-error>
                                </div>
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.contact_person')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.contact_person" name="contact_person" :placeholder="trans('configuration.contact_person')">
                                    <show-error :form-name="configForm" prop-name="contact_person"></show-error>
                                </div>
                            </div>
                        </section>
                        <section class="admin-config-section" :aria-label="trans('configuration.contact')">
                            <h4 class="admin-config-section__title">{{ trans('configuration.contact') }}</h4>
                            <p class="admin-config-section__description">Keep public contact and address details accurate for customer-facing communication.</p>
                            <div class="row">
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.address_line_1')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.address_line_1" name="address_line_1" :placeholder="trans('configuration.address_line_1')">
                                    <show-error :form-name="configForm" prop-name="address_line_1"></show-error>
                                </div>
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.address_line_2')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.address_line_2" name="address_line_2" :placeholder="trans('configuration.address_line_2')">
                                    <show-error :form-name="configForm" prop-name="address_line_2"></show-error>
                                </div>
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.city')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.city" name="city" :placeholder="trans('configuration.city')">
                                    <show-error :form-name="configForm" prop-name="city"></show-error>
                                </div>
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.state')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.state" name="state" :placeholder="trans('configuration.state')">
                                    <show-error :form-name="configForm" prop-name="state"></show-error>
                                </div>
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.zipcode')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.zipcode" name="zipcode" :placeholder="trans('configuration.zipcode')">
                                    <show-error :form-name="configForm" prop-name="zipcode"></show-error>
                                </div>
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.country')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.country" name="country" :placeholder="trans('configuration.country')">
                                    <show-error :form-name="configForm" prop-name="country"></show-error>
                                </div>
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.phone')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.phone" name="phone" :placeholder="trans('configuration.phone')">
                                    <show-error :form-name="configForm" prop-name="phone"></show-error>
                                </div>
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.fax')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.fax" name="fax" :placeholder="trans('configuration.fax')">
                                    <show-error :form-name="configForm" prop-name="fax"></show-error>
                                </div>
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.email')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.email" name="email" :placeholder="trans('configuration.email')">
                                    <show-error :form-name="configForm" prop-name="email"></show-error>
                                </div>
                                <div class="col-12 col-md-6 form-group">
                                    <label for="">{{trans('configuration.website')}}</label>
                                    <input class="form-control" type="text" value="" v-model="configForm.website" name="website" :placeholder="trans('configuration.website')">
                                    <show-error :form-name="configForm" prop-name="website"></show-error>
                                </div>
                            </div>
                        </section>
                        <div class="admin-config-actions">
                            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{ trans('general.save') }}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import configurationSidebar from '../system-config-sidebar'
    import vSelect from 'vue-multiselect'
    import datepicker from 'vuejs-datepicker'

    export default {
        components : { configurationSidebar,vSelect,datepicker },
        data() {
            return {
                configForm: new Form({
                    company_name : '',
                    contact_person: '',
                    address_line_1: '',
                    address_line_2: '',
                    city: '',
                    state: '',
                    zipcode: '',
                    country: '',
                    phone: '',
                    fax: '',
                    email: '',
                    website: '',
                    config_type: ''
                }, false),
            };
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }
            axios.get('/api/configuration')
                .then(response => response.data)
                .then(response => {
                    this.configForm = helper.formAssign(this.configForm, response);
                }).catch(error => {
                    helper.showDataErrorMsg(error);
                });
        },
        methods: {
            submit(){
                this.configForm.config_type = 'basic';
                this.configForm.post('/api/configuration')
                    .then(response => {
                        this.$store.dispatch('setConfig',this.configForm);
                        toastr.success(response.message);
                    }).catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>
